export default __webpack_public_path__ + "static/media/digital-people.528e8e2a.png";